import logger from './logger';
import SentryManager from './sentry-manager';

const reportUncaughtError = (error, errorInfo) => {
    logger.error('Uncaught render error:', errorInfo.componentStack);
    SentryManager.captureUncaughtError(error, errorInfo);
    reportError(error);
};

export default reportUncaughtError;
